import { z } from '../utils/zod-extend'

// NOTE: media ownerとmedia variantの組み合わせをtypeで制約をかけるようにしたい。
export const mediaOwnerTypes = [
  'Popup',
  'Survey',
  'Answer',
  'Campaign',
  'CampaignStampImage',
  'CampaignGameStampRally',
  'Thanks',
  'ComponentDesign',
  'ProductImage',
  'PageSetting',
] as const
export type MediaOwnerType = typeof mediaOwnerTypes[number]

export const mediaVariants = [
  'popupMainImage',
  'surveyQuestion',
  'surveyAnswer',
  'campaignMainImage',
  'campaignStampImage',
  'thanksMainImage',
  'buttonMainImage',
  'productImage',
  'campaignSelectionHeadingContentImage',
] as const
export type MediaVariantType = typeof mediaVariants[number]

export const mediaStorages = ['cloudflare'] as const
export type MediaStorageType = typeof mediaStorages[number]

export const mediaFileTypes = ['image', 'video'] as const
export type MediaFileType = typeof mediaFileTypes[number]

/**
 * image upload時の upload urlを生成 request params
 */
export const createUploadImageUrlSchema = z.object({
  ownerType: z.enum(mediaOwnerTypes),
  ownerId: z.string().nullish(),
  mediaVariant: z.enum(mediaVariants),
})
export type CreateUploadImageUrlValues = z.infer<typeof createUploadImageUrlSchema>

/**
 * video upload時の upload urlを生成 request params
 */
export const createUploadVideoUrlSchema = z.object({
  ownerType: z.enum(mediaOwnerTypes),
  ownerId: z.string().nullish(),
  mediaVariant: z.enum(mediaVariants),
})
export type CreateUploadVideoUrlValues = z.infer<typeof createUploadVideoUrlSchema>

export const connectMediaFilesToOwnerSchema = z.object({
  ownerType: z.enum(mediaOwnerTypes),
  ownerId: z.string().min(1),
  mediaUids: z.string().array().min(1),
}).openapi('ConnectMediaFilesToOwner')
export type ConnectMediaFilesToOwnerValues = z.infer<typeof connectMediaFilesToOwnerSchema>

export type UploadImageResponse = {
  // image url
  imageUrl: string
  // image media uid
  mediaUid: string
}

export type UploadVideoResponse = {
  // video stream(hls) url
  videoUrl: string
  // video thumbnail url
  thumbnailUrl: string
  mediaUid: string
}
